module.exports = __webpack_public_path__ + "assets/img/robot004.f221db60.jpg";